import type { JSX } from 'react'

import { styled } from '@linaria/react'
import { LAYOUT } from 'vars/layout-settings'

export const GridContainerSC = styled.div<{
  backgroundImage?: JSX.Element
}>`
  position: relative;
  min-height: 100%;

  > div:nth-child(2) {
    position: relative;
  }
`

export const PosterContainerSC = styled.div`
  position: fixed;
  top: var(${LAYOUT.NavbarSize});
  bottom: 0;
  left: 0;
  right: 0;

  img {
    width: 100%;
    height: 100vh;
    object-fit: cover;
  }
`
